if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        // Open the drawer on the tap with the product being added; the server render replaces it
        const opensDrawerNow = this.cart && typeof this.cart.showPending === 'function' && !this.closest('quick-add-modal');
        if (opensDrawerNow) {
          this.cart.setActiveElement(document.activeElement);
          this.cart.showPending(this.getPendingItem(new FormData(this.form)));
        }
        //this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              if (opensDrawerNow) this.cart.showPendingError(response.description || response.message);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            // Network failure or a non-JSON (e.g. throttled) response: tell the shopper instead of failing silently
            console.error(e);
            this.handleErrorMessage(window.cartStrings && window.cartStrings.error);
            if (opensDrawerNow) this.cart.showPendingError(window.cartStrings && window.cartStrings.error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      // What the drawer shows while the add is in flight: the variant the shopper picked,
      // at the price they will pay (subscription price when a selling plan is selected)
      getPendingItem(formData) {
        const variantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity')) || 1;
        const sellingPlanId = Number(formData.get('selling_plan')) || null;
        let variant = null;
        document
          .querySelectorAll('variant-radios script[type="application/json"], variant-selects script[type="application/json"]')
          .forEach((script) => {
            if (variant) return;
            try {
              variant = JSON.parse(script.textContent).find((candidate) => candidate.id === variantId) || null;
            } catch (error) {
              variant = null;
            }
          });

        let price = null;
        if (variant) {
          price = variant.price;
          const allocation =
            sellingPlanId &&
            (variant.selling_plan_allocations || []).find((entry) => entry.selling_plan_id === sellingPlanId);
          if (allocation) price = allocation.price;
        }
        const variantImage = variant && variant.featured_image && variant.featured_image.src;

        return {
          title: this.dataset.pendingTitle,
          image: variantImage ? `${variantImage}${variantImage.includes('?') ? '&' : '?'}width=160` : this.dataset.pendingImage,
          variantTitle: variant && variant.title !== 'Default Title' ? variant.title : '',
          price: price === null ? null : price * quantity,
          quantity,
          variantId,
          sellingPlanId
        };
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
